// Lib
import React from 'react';

// Components
import AiListButton, { AiListButtonTypes } from '../components/AiListButton';

// Constants
import { GENERATE_MORE_PROMPT_SHORTCUT } from '../../state/aiToolStateConstants';

// Types
import { PromptShortcut } from '../../../../../../../../common/ai/aiPromptShortcutTypes';

interface PromptShortcutButtonProps {
    shortcut: PromptShortcut;
    onClick: (shortcut: PromptShortcut) => void;
}

const getAiListButtonType = (shortcut: PromptShortcut): AiListButtonTypes => {
    if (shortcut.getPromptMethod) return AiListButtonTypes.AUTO_GENERATE;

    if (shortcut.id === GENERATE_MORE_PROMPT_SHORTCUT.id) return AiListButtonTypes.REFRESH;

    if (shortcut.children.length === 0 && !shortcut.requireTextInput) return AiListButtonTypes.SUBMIT;

    return AiListButtonTypes.ADVANCE;
};

const AiAssistantPopupPromptShortcutButton = ({ shortcut, onClick }: PromptShortcutButtonProps): React.ReactElement => (
    <AiListButton
        buttonType={getAiListButtonType(shortcut)}
        onClick={() => {
            onClick(shortcut);
        }}
    >
        {shortcut.isStreaming ? (
            <div className="animated-text">
                {shortcut.promptText?.split(' ').map((word, index) => (
                    <span key={index}>{`${word} `}</span>
                ))}
            </div>
        ) : (
            shortcut.promptText
        )}
    </AiListButton>
);

export default AiAssistantPopupPromptShortcutButton;
